import React, { Component } from "react";
import { SurveyCreator, } from "custom-survey-creator-react";
import { Serializer, JsonObject, Action } from "survey-core";
import "custom-survey-core/survey.i18n.js";
import "custom-survey-creator-core/survey-creator-core.i18n.js";
import "custom-survey-core/defaultV2.css";
import "custom-survey-creator-core/survey-creator-core.css";

// Error Boundary for SurveyJS
class SurveyErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('SurveyJS Error:', error, errorInfo);
  }

  render() {
    console.log('SurveyErrorBoundary render called, hasError:', this.state.hasError);
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>Survey Creator Error</h3>
          <p>Something went wrong with the survey creator. Please refresh the page.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const creatorOptions = {
  showLogicTab: false,
  showThemeTab: false,
  showTranslationTab: false,
  showEmbeddedSurveyTab: false,
  showJSONEditorTab: false,
  isAutoSave: true
};

//const defaultJson = {
  //"title": "SFP Application Form",
  //"description": "Please provide information about your sustainable finance product application",
 // "showProgressBar": "top",
 // "showNavigationButtons": "bottom",
  //"completedHtml": "<h3>Thank you for completing the application!</h3><p>Your SFP application form has been submitted successfully.</p>",
  //"pages": [
   // {
     // "name": "page1",
      //"title": "Application Information",
      //"elements": []
   // }
 // ]
//}
// const defaultJsonOld = {
//   "title": "Management of Chemicals in Products",
//   "description": "",
//   "completedHtml": "<h3>Thank you for your feedback.</h3> <h5>Your thoughts and ideas will help us to create a great product!</h5>",
//   "completedHtmlOnCondition": [
//     {
//       "html": "<h3>Thank you for your feedback.</h3> <h5>We glad that you love our product. Your ideas and suggestions will help us to make our product even better!</h5>"
//     },
//     {
//       "html": "<h3>Thank you for your feedback.</h3> <h5> We are glad that you share with us your ideas.We highly value all suggestions from our customers. We do our best to improve the product and reach your expectation.</h5><br/>"
//     }
//   ],
//   "Sector": "Consumer Goods",
//   "Sector Code": "CG",
//   "Industry": "Apparel, Accessories & Footwear",
//   "Industry Code": "CG-AA",
//   "pages": [
//     {
//       "name": "Page 1",
//       "title": "Discussion of processes to maintain compliance with restricted substances regulations",
//       "elements": [
//         {
//           "type": "panel",
//           "name": "question4",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.1",
//           "description": "CG-AA-250a.1.1 - The entity shall discuss the processes used to verify that its products comply with the restricted substances regulations to which the entity is subject.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question3",
//               "title": "Answer for CG-AA-250a.1.1",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question2",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:1 - Restricted substances regulations are defined as laws, rules and regulations that restrict or ban the use of some materials, chemicals and substances in finished home textile, apparel and footwear products.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:1"
//             }
//           ]
//         },
//         {
//           "type": "text",
//           "name": "question5",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.1.10 - Disclosures generally correspond to the Sustainable Apparel Coalition�s (SAC) Higg Brand & Retail Module.",
//           "tp_id": "CG-AA-250a.1",
//           "stp_id": "CG-AA-250a.1.10"
//         },
//         {
//           "type": "panel",
//           "name": "question10",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.1",
//           "description": "CG-AA-250a.1.2 - The entity shall discuss its use of finished product and product input labouratory testing and verification, restricted substance lists (RSLs), material supplier (vendor) agreements or input stream management.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question9",
//               "title": "Answer for CG-AA-250a.1.2",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question6",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:1 - An RSL is defined as a list of chemicals that the entity restricts from inclusion in materials, components and products that it produces. This list typically includes the common names of the chemicals, the restriction levels in the final product or tested component, and the test method.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:1"
//             },
//             {
//               "type": "text",
//               "name": "question7",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:2 - Material supplier agreements are defined as contracts between the entity and its manufacturing suppliers that limit regulated substances to their restricted levels in the products that the supplier manufactures.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:2"
//             },
//             {
//               "type": "text",
//               "name": "question8",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:3 - Input stream management is defined as a preventive process for monitoring and optimising chemical recipes, proactive reactants and reagents, or material inputs.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:3"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question16",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.1",
//           "description": "CG-AA-250a.1.3 - The entity shall discuss the verification and testing processes employed to confirm its materials maintain compliance with restricted substances regulations, including:",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question15",
//               "title": "Answer for CG-AA-250a.1.3",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question11",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:1 - Whether the entity tests finished product or each product input, defined as the components of the finished product;",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:1"
//             },
//             {
//               "type": "text",
//               "name": "question12",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:2 - Whether the entity conducts its own lab testing or if a third party conducts the testing;",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:2"
//             },
//             {
//               "type": "text",
//               "name": "question13",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:3 - The frequency of testing, including whether random sampling is conducted; and",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:3"
//             },
//             {
//               "type": "text",
//               "name": "question14",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:4 - Whether the entity has a standard operating procedure (SOP) for verifying compliance with restricted substances regulations as a part of its material selection and approval process.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:4"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question23",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.1",
//           "description": "CG-AA-250a.1.4 - The entity shall describe the scope of the RSLs used including whether the entity:",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question22",
//               "title": "Answer for CG-AA-250a.1.4",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question17",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:1 - Uses separate RSLs to manage legal compliance within each market in which it operates or applies a single RSL to products in all markets in which it operates, regardless of whether the RSL contains chemicals not regulated in some markets;",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:1"
//             },
//             {
//               "type": "text",
//               "name": "question18",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:2 - Uses one or more RSL that it has independently developed or if it uses an industry-accepted RSL, defined as an RSL that is promoted by an industry or trade organisation;",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:2"
//             },
//             {
//               "type": "text",
//               "name": "question19",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:3 - Uses an RSL that reflects the strictest regulation in all the countries or markets in which the brand operates and sells products (for example, regulations that apply to manufacturing, marketing and sales locations);",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:3"
//             },
//             {
//               "type": "text",
//               "name": "question20",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:4 - Uses an RSL that reflects the most restrictive allowable limits in all locations worldwide where the chemicals that may be used in the entity�s products are regulated; or",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:4"
//             },
//             {
//               "type": "text",
//               "name": "question21",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:5 - Uses one or more RSL that includes voluntary limits or bans of chemicals beyond the most restrictive global regulations, or if it includes chemicals that may not be subject to regulation but which the entity has voluntarily chosen to limit or ban from its products.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:5"
//             }
//           ]
//         },
//         {
//           "type": "text",
//           "name": "question24",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.1.5 - The strictest regulation is defined as the lowest allowable concentration of the regulated chemical found in any regulation in all locations worldwide where the chemical is regulated.",
//           "tp_id": "CG-AA-250a.1",
//           "stp_id": "CG-AA-250a.1.5"
//         },
//         {
//           "type": "panel",
//           "name": "question27",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.1",
//           "description": "CG-AA-250a.1.6 - The entity shall disclose whether the RSL used is publicly available and shall disclose its location.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question26",
//               "title": "Answer for CG-AA-250a.1.6",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question25",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:1 - Public disclosure is defined as online disclosure of the full list of chemicals on the RSL, their restriction limits and the regulations to which the chemicals are subject.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:1"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question32",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.1",
//           "description": "CG-AA-250a.1.7 - The entity shall disclose how it enforces compliance with restricted substances regulations within its supply chain, including:",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question31",
//               "title": "Answer for CG-AA-250a.1.7",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question28",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:1 - How it requires suppliers to demonstrate adherence (through self-declaration or if the entity includes RSL compliance requirements in supplier contracts or agreements);",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:1"
//             },
//             {
//               "type": "text",
//               "name": "question29",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:2 - Which tiers (Tier 1 or beyond Tier 1) of suppliers the entity directly verifies comply with restricted substance regulations; and",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:2"
//             },
//             {
//               "type": "text",
//               "name": "question30",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.1:3 - How the entity enforces corrective actions when it identifies non-compliance with its RSLs.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.1:3"
//             }
//           ]
//         },
//         {
//           "type": "text",
//           "name": "question33",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.1.8 - Tier 1 suppliers are defined as suppliers that transact directly with the entity, such as finished goods manufacturers (for example, cut and sew facilities).",
//           "tp_id": "CG-AA-250a.1",
//           "stp_id": "CG-AA-250a.1.8"
//         },
//         {
//           "type": "text",
//           "name": "question34",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.1.9 - Beyond Tier 1 suppliers are defined as the essential suppliers to the entity�s Tier 1 suppliers and can include manufacturers, processing plants, and providers of raw materials extraction (for example, mills, dye houses and washing facilities, sundry manufacturers, tanneries, embroiderers, screen printers, farms or slaughterhouses).",
//           "tp_id": "CG-AA-250a.1",
//           "stp_id": "CG-AA-250a.1.9"
//         }
//       ]
//     },
//     {
//       "name": "Page 2",
//       "title": "Discussion of processes to assess and manage risks or hazards associated with chemicals in products",
//       "elements": [
//         {
//           "type": "panel",
//           "name": "question37",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.1 - The entity shall discuss the business and operational processes employed to assess and manage potential risks and hazards associated with the use of materials, chemicals and substances (hereafter �chemicals�) in its products.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question36",
//               "title": "Answer for CG-AA-250a.2.1",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question35",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - The scope of the disclosure excludes chemicals management processes for chemicals used during manufacturing and production processes or that are associated with the production of raw materials or components of its products, but which are not present in finished products, which are addressed through CG-AA-430a.2.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question43",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.10 - The entity may identify chemicals in its finished products that it has selected for reduction, elimination or assessment, for reasons such as:",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question42",
//               "title": "Answer for CG-AA-250a.2.10",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question38",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - Incomplete or insufficient toxicity information such that the entity cannot determine if the chemical is safe for use;",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             },
//             {
//               "type": "text",
//               "name": "question39",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:2 - Pending or anticipated regulations that may limit or restrict the use of the chemical in the future;",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:2"
//             },
//             {
//               "type": "text",
//               "name": "question40",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:3 - Potential for environmental harm, but not harm to human health, the entity wishes to limit; and",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:3"
//             },
//             {
//               "type": "text",
//               "name": "question41",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:4 - Being �of concern� to consumers, customers, regulators or others (for example, non-governmental organisations or scientific researchers) even if the specific chemical or class of chemicals is unregulated.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:4"
//             }
//           ]
//         },
//         {
//           "type": "text",
//           "name": "question44",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.2.11 - If the entity has identified specific chemicals for elimination or substitution, it may discuss the time line to achieve those goals, identify which products or product lines will be affected by the elimination or substitution, and provide an analysis of progress towards achieving its goals.",
//           "tp_id": "CG-AA-250a.2",
//           "stp_id": "CG-AA-250a.2.11"
//         },
//         {
//           "type": "text",
//           "name": "question45",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.2.12 - Disclosures generally correspond to the Sustainable Apparel Coalition�s Higg Brand & Retail Module.",
//           "tp_id": "CG-AA-250a.2",
//           "stp_id": "CG-AA-250a.2.12"
//         },
//         {
//           "type": "text",
//           "name": "question46",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.2.2 - Where chemicals management policies and practices differ significantly by business unit, product category or geography, the entity shall describe those differences.",
//           "tp_id": "CG-AA-250a.2",
//           "stp_id": "CG-AA-250a.2.2"
//         },
//         {
//           "type": "panel",
//           "name": "question51",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.3 - The entity shall describe whether its approach to chemicals management is characterised by a hazard-based, risk-based or other approach.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question50",
//               "title": "Answer for CG-AA-250a.2.3",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question47",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - A hazard-based approach to chemicals management is defined as the process of identifying and managing the use of chemicals based on the toxicological characteristics of chemical ingredients as they relate to human health and the environment, including specific exposure routes (for example, oral, dermal or inhalation) and dosages (quantities) of a substance required to cause an adverse effect.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             },
//             {
//               "type": "text",
//               "name": "question48",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:2 - A risk-based approach to chemicals management is defined as the process of managing the use of chemicals by integrating chemical hazard information with an assessment of chemical exposure (route, frequency, duration and magnitude) to assess the probability and magnitude of harm to a given population.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:2"
//             },
//             {
//               "type": "text",
//               "name": "question49",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:3 - Other approaches may include the mixed use of hazard- and risk-based approaches depending on the particular chemical, product category, business segment, operating region or intended product user.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:3"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question56",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.4 - The entity shall discuss the operational processes employed for chemicals management, such that:",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question55",
//               "title": "Answer for CG-AA-250a.2.4",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question52",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - Relevant operational processes that characterise hazard-based approaches include limiting or restricting specific chemicals in a finished product because the chemicals may be prohibited by a regulation, or because they have known toxicity at levels at or below amounts detectable in finished products (for example, the use of a comprehensive restricted substances list (RSL) for banned chemicals where the entity operates or for chemicals the entity has chosen to limit or eliminate);",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             },
//             {
//               "type": "text",
//               "name": "question53",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:2 - Relevant operational processes that characterise risk-based management include evaluating chemical hazard data, conducting assessments of exposure pathways and identifying potential corresponding health risks using screening methods and chemical risk framework tools, such as the World Health Organization�s (WHO) Human Health Risk Assessment Toolkit: Chemical Hazards, the International Council of Chemical Association�s (ICCA) Guidance on Chemical Risk Assessment, and the Outdoor Industry Association�s (OIA) ChemUnity Guide of Chemicals Management Solutions; and",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:2"
//             },
//             {
//               "type": "text",
//               "name": "question54",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:3 - Additional frameworks for hazard- and risk-based chemical assessments include those compiled by the Organisation for Economic Co-operation and Development (OECD).",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:3"
//             }
//           ]
//         },
//         {
//           "type": "text",
//           "name": "question57",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.2.5 - The entity shall describe its approach to chemicals management in each stage of its products lifecycles, such as product design and planning, materials and chemicals procurement, manufacturing, finished-goods testing, product labelling and marketing, and end of life.",
//           "tp_id": "CG-AA-250a.2",
//           "stp_id": "CG-AA-250a.2.5"
//         },
//         {
//           "type": "text",
//           "name": "question58",
//           "title": "Type Your Question Here",
//           "description": "CG-AA-250a.2.6 - The entity shall describe how it prioritises chemicals for reduction or elimination from its products, and how it integrates alternative chemicals into product formulation and design, including through materials substitution assessments such as GreenScreen� For Safer Chemicals.",
//           "tp_id": "CG-AA-250a.2",
//           "stp_id": "CG-AA-250a.2.6"
//         },
//         {
//           "type": "panel",
//           "name": "question62",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.7 - The entity shall describe whether it designs products according to one or more green chemistry principles, including how it prioritises a set of chemicals from its full product portfolio and evaluates sourcing options and potential material innovation.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question61",
//               "title": "Answer for CG-AA-250a.2.7",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question59",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - Green chemistry principles are defined by the 12 Principles of Green Chemistry .",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             },
//             {
//               "type": "text",
//               "name": "question60",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:2 - A product shall be considered to have been designed with green chemistry principles if tools, frameworks, standards or certifications were used to integrate one or more green chemistry principles into the design, materials selection, manufacturing processes, use-phase or end-of-life disposal of the product.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:2"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question65",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.8 - The entity shall disclose whether it conducts testing or pursues third-party certifications to verify the chemical content of its finished products, including which certifications apply to which products.",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question64",
//               "title": "Answer for CG-AA-250a.2.8",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question63",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - Examples of third-party certifications that verify chemical content in products may include OEKO-TEX Standard 100 Certification, Eco-Passport, Bluesign and Intertek Eco-Certification.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             }
//           ]
//         },
//         {
//           "type": "panel",
//           "name": "question68",
//           "title": "Type Your Question Here",
//           "tp_id": "CG-AA-250a.2",
//           "description": "CG-AA-250a.2.9 - The entity shall describe how it coordinates with its suppliers to manage risks or hazards associated with chemicals in products, including:",
//           "elements": [
//             {
//               "type": "text",
//               "name": "question67",
//               "title": "Answer for CG-AA-250a.2.9",
//               "description": "",
//               "isRequired": true
//             },
//             {
//               "type": "text",
//               "name": "question66",
//               "title": "Type Your Question Here",
//               "description": "CG-AA-250a.2:1 - Whether and how it coordinates with its suppliers to implement its green chemistry programme, if extant, and if it rewards suppliers for participating.",
//               "isRequired": true,
//               "stp_id": "CG-AA-250a.2:1"
//             }
//           ]
//         }
//       ]
//     }
//   ]
// };


// Add a property to the Survey class
Serializer.addProperty("survey", {
  name: "customSurveyProperty",
  category: "general",
  visibleIndex: 0
});
// Add a property to the Page class
Serializer.addProperty("page", {
  name: "customPageProperty",
  category: "general",
  visibleIndex: 0
});
// Add a property to the base Question class and to all questions as a result
Serializer.addProperty("question", {
  name: "customNumericProperty",
  type: "number",
  category: "general",
  default: 1,
  visibleIndex: 0,
  onSetValue: (survey, value) => {
    // ...
    // You can perform required checks or modify the `value` here
    // ...
    // Set the `value`
    survey.setPropertyValue("customNumericProperty", value);
    // You can perform required actions after the `value` is set
    // ...
  }
});


Serializer.addProperties("question", {
  name: "tags:string",
  default: ""
})

Serializer.addProperty("survey", {
  name: "customSurveyProperty",
  category: "general",
  visibleIndex: 0
});

Serializer.addProperty("survey", {
  name: "Sector",
  category: "Tese",
  visibleIndex: 0
});

Serializer.addProperty("survey", {
  name: "Sector Code",
  category: "Tese",
  visibleIndex: 1
});

Serializer.addProperty("survey", {
  name: "Industry",
  category: "Tese",
  visibleIndex: 2
});

Serializer.addProperty("survey", {
  name: "Industry Code",
  category: "Tese",
  visibleIndex: 3
});

Serializer.addProperty("page", {
  name: "tags:string",
  category: "Tese",
  visibleIndex: 0
});

// Add a property to the Page class
Serializer.addProperty("page", {
  name: "Extra",
  category: "Tese",
  visibleIndex: 0
});

Serializer.addProperty("question", {
  name: "Technical Protocol",
  choices: [
    { value: "CG-AA-250a.1.2", text: "CG-AA-250a.1.2 - An RSL is defined as a list of chemicals that the entity restricts from inclusion in materials, components and products that it produces. This list typically includes the common names of the chemicals, the restriction levels in the final product or tested component, and the test method." },
    { value: "CG-AA-250a.1.3", text: "CG-AA-250a.1.3 - An d as a list of chemicals tha" },
    { value: "CG-AA-250a.1.4", text: "CG-AA-250a.1.4" },
    { value: "CG-AA-250a.1.5", text: "CG-AA-250a.1.5" },
    { value: "CG-AA-250a.1.6", text: "CG-AA-250a.1.6" },
    { value: "CG-AA-250a.1.7", text: "CG-AA-250a.1.7" },
    { value: "CG-AA-250a.1.8", text: "CG-AA-250a.1.8" },
    { value: "CG-AA-250a.1.9", text: "CG-AA-250a.1.9" },
    { value: "CG-AA-250a.1.10", text: "CG-AA-250a.1.10" }],
  category: "Tese",
  visibleIndex: 0,
  onSetValue: (survey, value) => {
    // ...
    // You can perform required checks or modify the `value` here
    // ...
    // Set the `value`
    survey.description = value;
    survey.setPropertyValue("tp_id", value);
    // TODO : Make a call to parent object and set desciption of the question according to value.
    // You can perform required actions after the `value` is set
    // ...
  }
});

Serializer.addProperty("question", {
  name: "Sub Technical Protocol",
  choices: [
    { value: "CG-AA-250a.1.2:1", text: "CG-AA-250a.1.2:1 - An RSL is defined as a list of chemicals that the entity restricts from inclusion in materials, components and products that it produces. This list typically includes the common names of the chemicals, the restriction levels in the final product or tested component, and the test method." },
    { value: "CG-AA-250a.1.3:2", text: "CG-AA-250a.1.3:2 - L is defined as a list of chemicals that the entity r" }
  ],
  category: "Tese",
  visibleIndex: 1,
  dependsOn: ["Technical Protocol"],
  visibleIf: (obj) => {
    return (
      true
      // obj.inputType != ""
      // obj.inputType === "date" ||
      // obj.inputType === "datetime" ||
      // obj.inputType === "datetime-local"
    );
  },
  onSetValue: (survey, value) => {
    // ...
    // You can perform required checks or modify the `value` here
    // ...
    // Set the `value`
    survey.description = value;
    survey.setPropertyValue("stp_id", value);
    // survey.setPropertyValue("description", "dddddkjdjdjdj");
    // x = survey.getQuestionByName("Sub Techincal Protocal");
    // if (!!x) question1.score = value;
    // You can perform required actions after the `value` is set
    // ...
  }
});


JsonObject.metaData.addProperty(
  "question", {
  name: "tags:string",
  default: ""
});

JsonObject.metaData.addProperty(
  "question", {
  name: "tp_id:string",
  default: ""
});

JsonObject.metaData.addProperty(
  "question", {
  name: "stp_id:string",
  default: ""
});


JsonObject.metaData.addProperty(
  "panel", {
  name: "tags:string",
  default: ""
});

JsonObject.metaData.addProperty(
  "panel", {
  name: "tp_id:string",
  default: ""
});

JsonObject.metaData.addProperty(
  "panel", {
  name: "stp_id:string",
  default: ""
});



export class SurveyCreatorRenderComponent extends Component {
  constructor(props) {
    super(props);
    this.creator = null;
    this.saveTimeout = null;
    this.initTimeout = null;
    this.isInitialized = false;
    this.state = {
      creatorReady: false
    };
    
    console.log('SurveyCreator constructor called with props:', props);
  }

  componentDidMount() {
    console.log('SurveyCreator componentDidMount called');
    // Add a small delay to ensure proper initialization
    this.initTimeout = setTimeout(() => {
      this.initializeCreator();
    }, 100);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customAssessment !== this.props.customAssessment) {
      this.updateSurveyJSON();
    }
    if (prevProps.formData !== this.props.formData) {
      this.updatePublishButton();
    }
  }

  componentWillUnmount() {
    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout);
    }
    if (this.initTimeout) {
      clearTimeout(this.initTimeout);
    }
  }

  initializeCreator = () => {
    console.log('initializeCreator called, isInitialized:', this.isInitialized);
    if (!this.isInitialized) {
      this.isInitialized = true;
      
      console.log('Creating SurveyCreator with options:', creatorOptions);
      const creator = new SurveyCreator(creatorOptions);
      this.creator = creator;
      console.log('SurveyCreator instance created:', creator);
      
      // Set state to trigger re-render
      this.setState({ creatorReady: true }, () => {
        console.log('Creator state set to ready');
        // Manually render the creator to the DOM after a short delay to ensure DOM is ready
        setTimeout(() => {
          try {
            const element = document.getElementById("surveyCreator");
            if (element) {
              creator.render("surveyCreator");
              console.log('Creator rendered to DOM');
            } else {
              console.error('Survey creator DOM element not found');
            }
          } catch (error) {
            console.error('Error rendering creator to DOM:', error);
          }
        }, 100);
      });
      
      creator.showSidebar = true;
      creator.toolbox.isCompact = true;
      creator.JSON = this.props.customAssessment || {};

      // Auto-save functionality
      const autoSave = () => {
        if (this.props.onSave && this.creator) {
          clearTimeout(this.saveTimeout);
          this.saveTimeout = setTimeout(() => {
            const surveyJson = this.creator.JSON;
            this.props.onSave(surveyJson).then(result => {
              if (result.success) {
                console.log('Auto-saved successfully');
                // Don't show toast for auto-save to avoid spam
              } else {
                console.error('Auto-save failed:', result.error);
                if (this.props.showError) {
                  this.props.showError('Auto-save failed');
                }
              }
            }).catch(error => {
              console.error('Auto-save error:', error);
              if (this.props.showError) {
                this.props.showError('Auto-save error');
              }
            });
          }, 2000); // Auto-save after 2 seconds of inactivity
        }
      };

      creator.onModified.add((sender, options) => {
        console.log('Survey modified:', JSON.stringify(options, null, 3));
        autoSave();
      });

      creator.onMachineTranslate.add((_, options) => {
        const translatedStrings = [];
        options.strings.forEach(str => { translatedStrings.push(options.toLocale + ": " + str); });
        options.callback(translatedStrings);
      });

      creator.onElementAllowOperations.add((sender, options) => {
        if (options.obj.isPage) {
          options.allowDelete = sender.survey.pageCount > 1;
        }
      });

      // Add toolbar buttons
      creator.toolbarItems.push(
        new Action({
          id: "saveForm",
          visible: true,
          title: "Save",
          enabled: true,
          action: () => {
            if (this.props.onSave && this.creator) {
              const surveyJson = this.creator.JSON;
              this.props.onSave(surveyJson).then(result => {
                if (result.success) {
                  console.log('Form saved successfully!');
                  // Success toast is already shown in App.js handleSaveForm
                } else {
                  console.error('Save failed:', result.error);
                  // Error toast is already shown in App.js handleSaveForm
                }
              }).catch(error => {
                console.error('Save error:', error);
                // Error toast is already shown in App.js handleSaveForm
              });
            } else {
              console.warn('Save function not available');
            }
          }
        })
      );

      // Initialize publish button
      this.updatePublishButton();
    }
  }

  updateSurveyJSON = () => {
    if (this.creator && this.props.customAssessment) {
      this.creator.JSON = this.props.customAssessment;
    }
  }

  updatePublishButton = () => {
    if (this.creator) {
      const isPublished = this.props.formData?.status === 'PUBLISHED';
      
      // Set default tab based on form status - open preview mode if published
      if (isPublished) {
        this.creator.activeTab = "test"; // "test" is the preview tab in SurveyJS
      }
      
      // Remove existing publish button if any
      const existingPublishIndex = this.creator.toolbarItems.findIndex(item => item.id === "publishForm");
      if (existingPublishIndex !== -1) {
        this.creator.toolbarItems.splice(existingPublishIndex, 1);
      }
      
      // Add updated publish button
      this.creator.toolbarItems.push(
        new Action({
          id: "publishForm",
          visible: true,
          title: isPublished ? "Published" : "Publish",
          enabled: !isPublished,
          action: () => {
            if (isPublished) {
              console.log('Form is already published');
              return;
            }
            
            if (this.props.onPublish && this.creator) {
              // First save the current form data, then publish
              if (this.props.onSave) {
                const surveyJson = this.creator.JSON;
                this.props.onSave(surveyJson).then(result => {
                  if (result.success) {
                    // After successful save, publish the form
                    this.props.onPublish();
                  } else {
                    console.error('Failed to save form before publishing:', result.error);
                  }
                }).catch(error => {
                  console.error('Save error before publish:', error);
                });
              } else {
                // If no save function, just publish
                this.props.onPublish();
              }
            } else {
              console.warn('Publish function not available');
            }
          }
        })
      );
    }
  }

  render() {
    console.log('SurveyCreator render called, creator exists:', !!this.creator, 'creatorReady:', this.state.creatorReady);
    return (
      <SurveyErrorBoundary>
        {this.state.creatorReady && this.creator ? (
          <div id="surveyCreator" style={{ height: "100vh", width: "100%" }}></div>
        ) : (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>Loading survey creator...</p>
            <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
              Creator exists: {!!this.creator ? 'Yes' : 'No'} | 
              Creator ready: {this.state.creatorReady ? 'Yes' : 'No'}
            </div>
          </div>
        )}
      </SurveyErrorBoundary>
    );
  }
}
